import React, { useLayoutEffect, useRef, useState } from 'react';
import ToolTip from '../common/ToolTip/ToolTip';

interface TenantNameProps {
    name: string;
}

export default function TenantName(props: TenantNameProps): JSX.Element {
    const textRef = useRef<HTMLSpanElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useLayoutEffect(() => {
        const textElement = textRef.current;
        if (!textElement) return;

        const updateOverflow = () => {
            setIsOverflowing(textElement.scrollWidth > textElement.clientWidth);
        };

        const animationFrame = window.requestAnimationFrame(updateOverflow);
        window.addEventListener('resize', updateOverflow);

        const resizeObserver = typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(updateOverflow);
        resizeObserver?.observe(textElement);

        return () => {
            window.cancelAnimationFrame(animationFrame);
            window.removeEventListener('resize', updateOverflow);
            resizeObserver?.disconnect();
        };
    }, [props.name]);

    return (
        <ToolTip className='tenant-name-tooltip' disabled={!isOverflowing}
            contents={<span className='tenant-name-text' ref={textRef} tabIndex={isOverflowing ? 0 : undefined}>{props.name}</span>}>
            <span className='tenant-name-tooltip-value'>{props.name}</span>
        </ToolTip>
    );
}
